import React from "react";
import { isString } from "lodash";
import styled from "styled-components";
import { Dot } from "@charty/legend/item";
import { FontSize, FontWeight, Radius, Spacing } from "@glossy";
import { sanitizeHTML } from "@tootools/dom";
import { parse } from "@tootools/emoji";

interface IProps {
  color?: string;
  label: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  subLabel?: string;
}

const Root = styled.div`
  text-align: left;
  font-size: ${FontSize.Medium};
  font-weight: ${FontWeight.Normal};
  border-radius: ${Radius.Medium};
  min-width: 150px;
  max-width: 300px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${Spacing.Small};
`;

const Label = styled.span`
  word-break: break-all;
`;

const SubLabel = styled.span`
  white-space: nowrap;
`;

const Footer = styled.div`
  font-size: ${FontSize.Medium};
  font-weight: ${FontWeight.Normal};
`;

const Tooltip = ({ color, label, subLabel, content, footer }: IProps) => (
  <Root>
    <Header>
      {!!color && <Dot color={color} />}
      {isString(label) ? (
        <Label dangerouslySetInnerHTML={sanitizeHTML(parse(label))} />
      ) : (
        <Label>{label}</Label>
      )}
      {subLabel && <SubLabel>{subLabel}</SubLabel>}
    </Header>
    {content}
    {footer && <Footer>{footer}</Footer>}
  </Root>
);

export default Tooltip;
